import React, { Component } from "react";
import { Redirect, BrowserRouter as Router, NavLink } from "react-router-dom";
import { addTab } from "./../../store/broadcaster/BroadcastRegister";
import SidebarDrawer from "./sidebarDrawer";
import { Popover ,Spin} from "antd";
import "./Sidebar.css";
import MirraLogo from "../images/new_mirra_logo_small.png";
import ElibilityIcon from "../images/Eligible.svg";
import claim from "../images/Claims.svg";
import ProfileIcon from "../images/profileicon.svg";
import Auth from "../images/AuthListIcon.png";
import MemberIcon from "../images/Member.svg";
import EligibilityActive from "../images/E_C_Active.svg";
import SearchActive from "../images/Search_Active.svg";
import AuthActive from "../images/Auth_Active.svg";
import UserActive from "../images/User_Active.svg";
import ReportActive from "../images/Active_Reports.svg";
import ClaimsActive from "../images/Claims_Active.svg";
import Ic4 from "../images/userlist.svg";
import ReportImg from "../images/Inactive_Reports.svg";
import ReportInactive from "../images/Inactive_Reports_Icon.svg";
import AttestationInactive from "../images/AttestationInactive.png";
import AttestationPending from "../images/AttestationPending.png";
import AttestationPending2 from "../images/AttestationPending2.png";
import AttestationActive from "../images/AttestationActive.png";
import Ic5 from "../images/Ic4.svg";
import menu1 from "../images/menu.svg";
import Profile from "../images/Profile.svg";
import Notify from "../images/Notify.svg";
import Message from "../images/message.svg";
import ApplicationGuide from "../images/ApplicationGuide.svg";
import ProfileSearchInActive from "../images/BoxSearchIcon.svg";
import ProfileSearchActive from "../images/ProfileSearchActive.svg";
import Config from "../../config";
import QueuesIcon from "../images/Group 3700(1).svg";
import ActiveQueues from "../images/Queues_Active.svg";
import ChaptershospiceIcon from "../images/ReportLogos/chaptershospiceIcon.png";
import SolisLogo from "../images/ReportLogos/Solis-New LOGO 2025.png";
import cshLogo from '../images/ReportLogos/cshSidebarLogo.png';
import securLogo from '../images/ReportLogos/SCR-SECUR-VerticalColorLogo.png';

var id = 1;

export default class Sidebar extends Component {
  constructor(props) {
    super();
    this.state = {
      id: "",
      current: "0",
      redirect: false,
      visible: false,
      docUrl: "",
      pagePathName: window.location.pathname.toString().toLowerCase(),
      isCSNPLoading: true
    };
  }

  // Changing the menu icon from default to active.

  tempNonAdminCheck = () => {
    //console.log("console");
    if(sessionStorage.getItem("PlanAdminRole") !== "Plan Admin"){
      if(!sessionStorage.getItem("taxidNpiMapping") 
      && !sessionStorage.getItem("taxid") 
      && !sessionStorage.getItem("npivalue"))
        return false;
    }
    return true;
  }

  showDrawer = () => {
    this.setState({
      visible: true,
    });
  };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };

  getRoterIndex = (key) => {
    id = key;
  };

  openDocument = () => {
    let a = document.getElementById("app-doc");
    a.target = "_blank";
    a.href = sessionStorage.getItem("ApplicationGuideURL");
  };

  checkGroupUsers = () => {
    // this method will check for Group User & IPA User
    let roles = sessionStorage.getItem("rolename");
    return (
      roles && (roles.includes("Group User") || roles.includes("IPA User"))
    );
  };

  showApplicationGuide = () => {
    const planName = sessionStorage.getItem("planName");
    let axiosConfig = {
      headers: {
        Authorization: sessionStorage.getItem("access_token"),
        Accept: "application/pdf",
      },
      responseType: "arraybuffer",
    };
    fetch(
      `${Config.api}/DownloadUserReferenceGuide?planName=${encodeURIComponent(planName)}`,
      axiosConfig
    )
      .then((res) => res.blob())
      .then((res) => {
        let blob = new Blob([res], { type: "application/pdf" });
        const fileURL = URL.createObjectURL(blob);
        this.setState({
          docUrl: fileURL,
        });
        sessionStorage.setItem("ApplicationGuideURL", fileURL);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  componentDidMount() {
    //this.showApplicationGuide();
    this.setState({
      isCSNPLoading:
        sessionStorage.getItem("IsCSNPPendingLoading") === "true"
    });
  
    window.addEventListener(
      "csnpResponseReceived",
      this.handleCSNPResponse
    );
  }
  componentWillUnmount() {
    window.removeEventListener(
      "csnpResponseReceived",
      this.handleCSNPResponse
    );
  }
  handleCSNPResponse = (event) => {
    this.setState({
      isCSNPLoading: false
    });
  }; 

  logout = () => {
    // console.log("Anshul");

    const data = {
      User: sessionStorage.getItem("userName"),
      UserName: sessionStorage.getItem("userEmail"),
      // IpAddress: "patient.locationInfo",
      Activity: "Logoff",
      TenantID: sessionStorage.getItem("Tanent"),
    };

    fetch(Config.api + "/UserTrackingDetails", {
      method: "POST",
      headers: {
        Authorization: sessionStorage.getItem("access_token"),
        "Content-type": "application/json",
      },
      body: JSON.stringify(data),
    });
    console.log(data);

    console.log(data);

    sessionStorage.setItem("userData", "");
    sessionStorage.clear();
    this.setState({ redirect: true });
  };

  render() {
    const planName = sessionStorage.getItem("planName");
    const applicationGuideURL = sessionStorage.getItem("ApplicationGuideURL");
    // console.log(this.state.id, index);
    addTab.next(null);
    let userName = sessionStorage.getItem("userName");
    if (this.state.redirect) {
      return <Redirect to={(window.location.pathname = "/login")} />;
    }
    return (
      // <Router>
      <div className="side-bar-parent card-view">
        <ul className="sidebar-ul" style={{ height: "19%" }}>
          <li>
            <div className="side-bar-title">P.P.</div>
          </li>

          {sessionStorage.getItem("planName") !== "csh" && (
            <li>
            <div className="div-pmLogo">
              <img
                src={MirraLogo}
                // style={{ width: "55px" }}
                alt="Logo"
                className="pmLogo"
              />
            </div>
          </li>
          )}
          {
            sessionStorage.getItem("planName") === 'solis' && 
            <li>
              <div>
                <img
                  src={SolisLogo}
                  // style={{ width: "55px" }}
                  alt="Logo"
                  className="solisLogo"
                />
              </div>
            </li>
          }
          {
            sessionStorage.getItem("planName") === 'chaptershospice' && 
            <li>
              <div>
                <img
                  src={ChaptershospiceIcon}
                  // style={{ width: "55px" }}
                  alt="Logo"
                  className="solisLogo"
                />
              </div>
            </li>
          }
          {
            sessionStorage.getItem("planName") === 'secur' && 
            <li>
              <div>
                <img
                  src={securLogo}
                  // style={{ width: "55px" }}
                  alt="Logo"
                  className="securLogo"
                />
              </div>
            </li>
          }
          {
            sessionStorage.getItem("planName") === 'csh' && 
            <li>
              <div>
                <img
                  src={cshLogo}
                  // style={{ width: "55px" }}
                  alt="Logo"
                  className="cshLogo2"
                />
              </div>
            </li>
          }
          
        </ul>
          
        <ul className="sidebar-ul sidebar-ul-active" style={{ height: "45%" }}>

          {/* 1. Eligibility Check */}
          {(
            (sessionStorage.getItem("ProviderRole") === "PROVIDER" ||
              this.checkGroupUsers() ||
              sessionStorage.getItem("PlanAdminRole") === "Plan Admin"
            ) &&
            sessionStorage.getItem("planName") === "csh"
          ) && (
              <li className="bar-li" onClick={() => this.getRoterIndex(1)}>
                <NavLink
                  to="/EligibilityCheck"
                  exact
                  activeStyle={{
                    backgroundColor: "#427BDDEB",
                    padding: "11px",
                    borderRadius: "0px 4px 4px 0px",
                  }}
                >
                  <abbr title="Member Search">
                    {this.state.pagePathName === "/eligibilitycheck" ? (
                      <img
                        src={EligibilityActive}
                        alt="EligibilityCheck"
                        style={{ cursor: "pointer", width: "20px", height: "20px" }}
                      />
                    ) : (
                      <img
                        src={ElibilityIcon}
                        alt="EligibilityCheck"
                        style={{ cursor: "pointer", width: "20px", height: "20px" }}
                      />
                    )}
                  </abbr>
                </NavLink>
              </li>
            )}


          {/* 2. Member Search */}
          {(sessionStorage.getItem("ProviderRole") === "PROVIDER" ||
            this.checkGroupUsers() ||
            sessionStorage.getItem("PlanAdminRole") === "Plan Admin") &&
            sessionStorage.getItem("planName") !== "csh" &&
            sessionStorage.getItem("EligibilityOnlyFlag") === "false" && (
              <li className="ic2-li" onClick={() => this.getRoterIndex(3)}>
                <NavLink
                  to="/Search_member"
                  activeStyle={{
                    backgroundColor: "#427BDDEB",
                    padding: "11px",
                    borderRadius: "0px 4px 4px 0px",
                  }}
                >
                  <abbr title="Member Search">
                    {this.state.pagePathName === "/search_member" ? (
                      <img src={ProfileSearchActive} alt="Search_member" style={{ cursor: "pointer", width: "20px", height: "20px" }} />
                    ) : (
                      <img src={ProfileSearchInActive} alt="Search_member" style={{ cursor: "pointer", width: "20px", height: "20px" }} />
                    )}
                  </abbr>
                </NavLink>
              </li>
            )}


          {/* 3. Claims Search */}
          {(sessionStorage.getItem("ProviderRole") === "PROVIDER" ||
            this.checkGroupUsers() ||
            sessionStorage.getItem("PlanAdminRole") === "Plan Admin") &&
            sessionStorage.getItem("EligibilityOnlyFlag") === "false" &&
            this.tempNonAdminCheck() && (
              <li onClick={() => this.getRoterIndex(2)}>
                <NavLink
                  to="/ClaimsTable"
                  activeStyle={{
                    backgroundColor: "#427BDDEB",
                    padding: "11px",
                    borderRadius: "0px 4px 4px 0px",
                  }}
                >
                  <abbr title="Claim Search">
                    {this.state.pagePathName === "/claimstable" ? (
                      <img src={ClaimsActive} alt="ClaimsTable" style={{ cursor: "pointer", width: "20px", height: "20px" }} />
                    ) : (
                      <img src={claim} alt="ClaimsTable" style={{ cursor: "pointer", width: "20px", height: "20px" }} />
                    )}
                  </abbr>
                </NavLink>
              </li>
            )}


          {/* 4. Authorization Search */}
          {(sessionStorage.getItem("ProviderRole") === "PROVIDER" ||
            this.checkGroupUsers() ||
            sessionStorage.getItem("PlanAdminRole") === "Plan Admin") &&
            (["ultimate", "sonder", "csh", "solis", "demo",  "secur"].includes(sessionStorage.getItem("planName"))) &&
            sessionStorage.getItem("EligibilityOnlyFlag") === "false" &&
            sessionStorage.getItem("planName") !== "PodAmerica" &&
            sessionStorage.getItem("planName") !== "chapters" &&
            this.tempNonAdminCheck() && (
              <li className="ic2-li" onClick={() => this.getRoterIndex(4)}>
                <NavLink
                  to="/auth_user_list"
                  activeStyle={{
                    backgroundColor: "#427BDDEB",
                    padding: "12px 10px",
                    borderRadius: "0px 4px 4px 0px",
                  }}
                >
                  <abbr title="Auth List">
                    {this.state.pagePathName === "/auth_user_list" ? (
                      <img src={AuthActive} alt="auth_user_list" style={{ cursor: "pointer", width: "20px", height: "20px", marginLeft: "6px" }} />
                    ) : (
                      <img src={Auth} alt="auth_user_list" style={{ cursor: "pointer", width: "20px", height: "20px", marginLeft: "6px" }} />
                    )}
                  </abbr>
                </NavLink>
              </li>
            )}


          {/* 5. Attestation Search (Now for Solis, UHP) */}
          {(planName === "solis" ||
            planName === "ultimate") &&
            sessionStorage.getItem("EligibilityOnlyFlag") === "false" && (
              <li className="ic2-li" onClick={() => this.getRoterIndex(8)}>
                <NavLink
                  to="/attestation"
                  activeStyle={{
                    backgroundColor: "#427BDDEB",
                    padding: "10px 10px",
                    borderRadius: "0px 4px 4px 0px",
                  }}
                >
                  <abbr title="Attestation Search">
                  { this.state.isCSNPLoading ? (
                    <div>
                    <Spin size="small"/> {/* Spinner overlay while loading */}
                  </div>
                     ) :
                    this.state.pagePathName === "/attestation" ? (
                      (localStorage.getItem("IsCSNPPending") === "true" ||
                        localStorage.getItem("IsSSBCIPending") === "true") ? (
                        <img src={AttestationPending2} alt="pending" style={{ cursor: "pointer", width: "25px", height: "25px", marginLeft: "5px" }} />
                      ) : (
                        <img src={AttestationInactive} alt="attestation" style={{ cursor: "pointer", width: "20px", height: "20px", marginLeft: "5px" }} />
                      )
                    ) : (
                      (localStorage.getItem("IsCSNPPending") === "true" ||
                        localStorage.getItem("IsSSBCIPending") === "true") ? (
                        <img src={AttestationPending2} alt="pending" style={{ cursor: "pointer", width: "30px", height: "30px", marginLeft: "5px" }} />
                      ) : (
                        <img src={AttestationActive} alt="attestation" style={{ cursor: "pointer", width: "30px", height: "30px", marginLeft: "5px" }} />
                      )
                    )}
                  </abbr>
                </NavLink>
              </li>
            )}


          {/* 6. User Search */}
          {sessionStorage.getItem("AdminRole") === "User Admin" &&
            sessionStorage.getItem("EligibilityOnlyFlag") === "false" && (
              (sessionStorage.getItem("ProviderRole") === "PROVIDER" ||
                this.checkGroupUsers() ||
                sessionStorage.getItem("PlanAdminRole") === "Plan Admin") ? (
                <li className="ic4-li" onClick={() => this.getRoterIndex(5)}>
                  <NavLink
                    to="/userDetails"
                    activeStyle={{
                      backgroundColor: "#427BDDEB",
                      padding: "11px",
                      borderRadius: "0px 4px 4px 0px",
                    }}
                  >
                    <abbr title="User Search">
                      {this.state.pagePathName === "/userdetails" ? (
                        <img src={UserActive} alt="List" style={{ cursor: "pointer", width: "20px", height: "20px" }} />
                      ) : (
                        <img src={Ic4} alt="List" style={{ cursor: "pointer", width: "20px", height: "20px" }} />
                      )}
                    </abbr>
                  </NavLink>
                </li>
              ) : (
                <li className="ic4-li">
                  <NavLink
                    to="/userDetails"
                    activeStyle={{
                      backgroundColor: "#427BDDEB",
                      padding: "11px",
                      borderRadius: "0px 4px 4px 0px",
                    }}
                  >
                    <abbr title="User Search">
                      <img src={Ic4} alt="List" style={{ cursor: "pointer", width: "20px", height: "20px" }} onClick={() => this.getRoterIndex(5)} />
                    </abbr>
                  </NavLink>
                </li>
              )
            )}


          {/* 7. Reports */}
          {(["ultimate", "csh", "demo", "solis", "secur"].includes(sessionStorage.getItem("planName"))) &&
            (sessionStorage.getItem("ProviderRole") === "PROVIDER" ||
              this.checkGroupUsers() ||
              sessionStorage.getItem("PlanAdminRole") === "Plan Admin") &&
            sessionStorage.getItem("EligibilityOnlyFlag") === "false" &&
            sessionStorage.getItem("planName") !== "PodAmerica" &&
            sessionStorage.getItem("planName") !== "sonder" &&
            sessionStorage.getItem("planName") !== "chapters" &&
            this.tempNonAdminCheck() && (
              <li className="ic4-li" onClick={() => this.getRoterIndex(6)}>
                <NavLink
                  to="/reports"
                  activeStyle={{
                    backgroundColor: "#427BDDEB",
                    padding: "11px",
                    borderRadius: "0px 4px 4px 0px",
                  }}
                >
                  <abbr title="Report">
                    {this.state.pagePathName === "/reports" ? (
                      <img src={ReportActive} alt="List" style={{ cursor: "pointer", width: "20px", height: "20px" }} />
                    ) : (
                      <img src={ReportInactive} alt="List" style={{ cursor: "pointer", width: "20px", height: "20px" }} />
                    )}
                  </abbr>
                </NavLink>
              </li>
            )}

        </ul>


        <hr className="devider"></hr>

        <ul className="sidebar-ul mcd-menu" style={{ height: "22%" }}>
          <li className="notification-li">
            {/* <img src={ApplicationGuide} className="notification applicationGuide" alt="ApplicationGuide"/> */}
            <Popover
              placement="rightTop"
              content={
                <div className="popup-text-header">User Guide</div>
              }
              trigger="hover"
            >
              {/* <a id="app-doc">
                <img
                   onClick={imageLoaded ? this.openDocument : null} // Conditional onClick
                  src={ApplicationGuide}
                  className="notification applicationGuide"
                  alt="ApplicationGuide"
                />
              </a> */}
               <a id="app-doc" style={{ position: 'relative', display: 'inline-block' }}>
          {applicationGuideURL == null && (
            <div
              className="spinner-overlay"
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(255, 255, 255, 0.7)',
                zIndex: 1,
              }}
            >
              <Spin /> {/* Spinner overlay while loading */}
            </div>
          )}
          {applicationGuideURL !== null && (
           <a id="app-doc">
           <img
             onClick={() => this.openDocument()}
             src={ApplicationGuide}
             className="notification applicationGuide"
             alt="ApplicationGuide"
           />
         </a>
          )}
        </a>
            </Popover>
          </li>
          {/* <li className="notification-li">
            
            <img src={Notify} className="notification" alt="Notification" />
            
          </li>
          <li className="message-li">
            
            <img src={Message} className="message" alt="Messages" />
         
          </li> */}
          <li className="user-li " onClick={() => this.getRoterIndex(7)}>
            <Popover
              placement="rightTop"
              content={
                <div>
                  <div className="popup-text-header">
                    Hello,{userName != null ? userName : ""}
                  </div>
                  <div className="popup-text-subtext mt-2"></div>
                  <a onClick={this.logout}>
                    <b>Logout</b>
                  </a>
                  {/* <div className="popup-logout mt-4"></div> */}
                </div>
              }
              trigger="hover"
            >
              {sessionStorage.getItem("AdminRole") === "User Admin" &&
              sessionStorage.getItem("ProviderRole") === "PROVIDER" ? (
                <NavLink
                  to="/Profile"
                  activeStyle={{
                    backgroundColor: "#427BDDEB",
                    padding: "11px",
                    borderRadius: "0px 4px 4px 0px",
                  }}
                >
                  <img
                    id="h"
                    style={{
                      cursor: "pointer",
                      width: 26,
                      height: 26,
                    }}
                    src={Profile}
                    alt="profile"
                  />
                </NavLink>
              ) : sessionStorage.getItem("ProviderRole") === "PROVIDER" ? (
                <NavLink
                  to="/Profile"
                  activeStyle={{
                    backgroundColor: "#427BDDEB",
                    padding: "11px",
                    borderRadius: "0px 4px 4px 0px",
                  }}
                >
                  <img
                    id="h"
                    style={{
                      cursor: "pointer",
                      width: 26,
                      height: 26,
                    }}
                    src={Profile}
                    alt="profile"
                  />
                </NavLink>
              ) : (
                <img
                  id="h"
                  style={{
                    cursor: "pointer",
                    width: 26,
                    height: 26,
                  }}
                  src={Profile}
                  alt="profile"
                />
              )}
            </Popover>
          </li>
        </ul>

        <div className="devider"></div>

        <ul
          className="sidebar-ul"
          style={{
            marginTop: "20px",
            height: "5%",
            background: "#4583EF",
            borderRadius: "0px 4px 4px 0px",
          }}
        >
          <li className="menulist-li">
            {/* <Link to="/" > */}
            <img
              src={menu1}
              alt="Menu list"
              onClick={this.showDrawer}
              style={{ width: "24px", height: "24px" }}
            />
            {this.state.visible && (
              <SidebarDrawer
                visible={this.state.visible}
                onClose={this.onClose}
                Index={id}
                GetIndex={this.getRoterIndex}
              />
            )}
            {/* </Link> */}
          </li>
        </ul>
      </div>
      // </Router>
    );
  }
}
